module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeBAMAAADJHrORAAAAJ1BMVEUAAADg4ODh4eHh4eHg4ODg4ODg4ODf39/g4ODf39/f39/f39/g4OClLJSUAAAADHRSTlMAgJ9fIN/PEK+QUDBF4Ya4AAAASUlEQVQY02PAAhgPovJ5zgigyp9BUyBzRgFNwaHBp6DnjAMyl/nMMRRpmzPpaNIFlEgfdUCVDiFBmgtNmg1VmoETIo0A2xlwAgA6zSbWLtoWzQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/right_arrow.png
// module id = mInU
// module chunks = 16